module.exports = __webpack_public_path__ + "img/cleaning-blue.1e60f71d.svg";